import { gql } from 'graphql-request'

export const UPDATE_SEARCH_KEYWORD = gql`
  mutation UpdateSearchKeyword(
    $updateSearchKeywordInput: UpdateSearchKeywordInput!
  ) {
    updateSearchKeyword(updateSearchKeywordInput: $updateSearchKeywordInput)
  }
`
